<template>
  <section id="usgs-header">
    <header id="navbar" class="header-nav" role="banner">
      <div class="usgs-header-container">
        <a class="logo-header" href="https://www.usgs.gov/" title="Home">
          <img
            class="img"
            src="@/assets/usgsHeaderAndFooter/images/logo.png"
            alt="Home"
          />
        </a>
      </div>
    </header>
  </section>
</template>

<script>
export default {
  name: "HeaderUSGS",
};
</script>

<style scoped lang="scss">
header {
  display: block;
  margin-bottom: 15px;
}
.tmp-container {
  margin-right: auto;
  padding-right: 15px;
}
/* header (only) nav */
.header-nav {
  background: #00264c;
}
.logo-header img {
  margin-top: 10px;
  margin-left: 10px;
  max-width: 100%;
  height: 65px;
}
</style>
